import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Doctor } from '../../interfaces/doctor';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DoctorService {
  protected apiVersion = environment.apiVersion;
  private apiUrl = environment.apiUrl;

  constructor(protected httpClient: HttpClient) {
    this.apiUrl = this.apiUrl + '/v' + this.apiVersion;
  }

  async getDoctors(cdEstabelecimento?: number | null): Promise<Doctor[]> {
    let params = new HttpParams();
    if (cdEstabelecimento != null) params = params.set('cdEstabelecimento', String(cdEstabelecimento));
    const doctors = await firstValueFrom(
      this.httpClient.get<any>(`${this.apiUrl}/Doctor/get-doctors`, { params }),
    );
    return doctors.data[0];
  }
}
